import { render, staticRenderFns } from "./day_print_spelling.vue?vue&type=template&id=17487fd2&scoped=true"
import script from "./day_print_spelling.vue?vue&type=script&lang=js"
export * from "./day_print_spelling.vue?vue&type=script&lang=js"
import style0 from "./day_print_spelling.vue?vue&type=style&index=0&id=17487fd2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17487fd2",
  null
  
)

export default component.exports